export const SUPPLIER_QUESTIONNAIRE_CATEGORIES = Object.freeze({
  PRODUCT: "PRODUCT",
  REVENUE: "REVENUE",
  LOCATION: "LOCATION",
  DECARBONIZATION: "DECARBONIZATION"
});

export const areArraysEqual = (array1, array2) => {
  if (array1.length === array2.length) {
    return array1.every(element => {
      if (array2.includes(element)) {
        return true;
      }
      return false;
    });
  }

  return false;
};